import React, { useRef, useEffect, useState } from "react";
import ModalDropdown from "../../component/ModalDropdown";
import CloseIcon from "@mui/icons-material/Close";
import InputBox from "../../component/InputBox";
import Button from "../../component/Button";
import { FormProvider, useForm } from "react-hook-form";
import classes from "./style.module.scss";
import Exported from "../../service/endpoints";
import request from "../../service";
import { Toast } from "../../service/toast";
import { saveLoadingState } from "../../redux/reducers/loadingSlice";
import { useDispatch } from "react-redux";
import GetUserPermission from "../../component/GetUserPermission";
import { useNavigate } from "react-router-dom";

const AddTarget = (props) => {
    const {
        isOpen = false,
        closePopUp,
        handleSuccessModal,
        isEdit,
        id,
        value
    } = props;
    const selectBoxRef = useRef();
    const dispatch = useDispatch();


    const formMethods = useForm({
        mode: "onSubmit",
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        trigger,
        setValue,
        getValues,
    } = formMethods;


    useEffect(() => {
        setValue("silver", value["Silver Membership"] ? value["Silver Membership"] : "");
        setValue("gold", value["Gold Membership"] ? value["Gold Membership"] : "");
        setValue("platinum", value["Platinum Membership"] ? value["Platinum Membership"] : "");
    }, [value, setValue]);

    const onSubmit = async (data) => {
        console.log("Form Data: ", data);
        trigger();



        dispatch(saveLoadingState(true));
        let requestData = {
            membership_points: {
                "Silver Membership": getValues("silver"),
                "Gold Membership": getValues("gold"),
                "Platinum Membership": getValues("platinum")
            }
        };

        await request({
            url: `${Exported.Endpoints.setTarget}/${id}`,
            method: Exported.APIMethods.PUT,
            data: requestData,
        })
            .then((res) => {
                if (res?.data?.status) {
                    dispatch(saveLoadingState(false));
                    handleSuccessModal();
                }
            })
            .catch((err) => {
                Toast({
                    type: "error",
                    message: "Unable to process the request!..",
                });
            });
        dispatch(saveLoadingState(false));
    };

    return (
        <>
            <ModalDropdown
                isOpen={isOpen}
                closePopUp={closePopUp}
                selectBoxRef={selectBoxRef}
            >
                <div className={`${classes.addMembershipWrapper}`}>
                    <div
                        className={`${classes.modalHeader} flex items-center justify-between`}>
                        <div className={`${classes.modalTitle}`}>
                            Set Target
                        </div>
                        <div className={`${classes.modalCloser}`}>
                            <CloseIcon onClick={() => closePopUp()} />
                        </div>
                    </div>
                    <div className={`${classes.reasonFormContainer}`}>
                        <FormProvider {...formMethods}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className={`${classes.formField} !mb-5 grid grid-cols-2 gap-2`}>
                                    <div className={`w-[100%] border border-[#D9D9D9] flex items-center rounded pl-2 ${classes.notesInput}`}>
                                        Silver Membership
                                    </div>

                                    <InputBox
                                        label={"Points"}
                                        className={`w-[100%] ${classes.notesInput}`}
                                        name={"silver"}
                                        {...register("silver", {
                                            required: true,
                                            validate: (value) => {
                                                const parsedValue = parseFloat(value);
                                                if (parsedValue < 0) {
                                                    return "Silver Points must be greater than 0";
                                                }
                                                if (parsedValue >= parseFloat(getValues("gold"))) {
                                                    return "Silver Points cannot be greater than or equal to Gold Points";
                                                }
                                                if (parsedValue >= parseFloat(getValues("platinum"))) {
                                                    return "Silver Points cannot be greater than or equal to Platinum Points";
                                                }
                                                return true;
                                            }
                                        })}
                                        placeholder={"Points"}
                                        error={errors?.silver}
                                        messages={{
                                            required: "Silver Points is required",
                                            validate : "Silver Points cannot be greater than or equal to Gold or Platinum Points or less than 0"
                                        }}
                                        isEdit={isEdit}
                                    />

                                </div>
                                <div className={`${classes.formField} !mb-5 grid grid-cols-2 gap-2`}>
                                    <div className={`w-[100%] border border-[#D9D9D9] flex items-center rounded pl-2 ${classes.notesInput}`}>
                                        Gold Membership
                                    </div>

                                    <InputBox
                                        label={"Points"}
                                        className={`w-[100%] ${classes.notesInput}`}
                                        name={"gold"}
                                        {...register("gold", {
                                            required: true,
                                            validate: (value) => {
                                                const parsedValue = parseFloat(value);
                                                if (parsedValue < 0) {
                                                    return "Gold Points must be greater than 0";
                                                }
                                                if (parsedValue >= parseFloat(getValues("platinum"))) {
                                                    return "Gold Points cannot be greater than or equal to Platinum Points";
                                                }
                                                return true;
                                            }
                                        })}
                                        placeholder={"Points"}
                                        error={errors?.gold}
                                        messages={{
                                            required: "Gold Points is required",
                                            validate : "Gold Points cannot be greater than or equal to Platinum Points or less than 0"
                                        }}
                                        isEdit={isEdit}
                                    />

                                </div>
                                <div className={`${classes.formField} !mb-5 grid grid-cols-2 gap-2`}>
                                    <div className={`w-[100%] border border-[#D9D9D9] flex items-center rounded pl-2 ${classes.notesInput}`}>
                                        Platinum Membership
                                    </div>

                                    <InputBox
                                        label={"Points"}
                                        className={`w-[100%] ${classes.notesInput}`}
                                        name={"platinum"}
                                        {...register("platinum", {
                                            required: true,
                                            validate: (value) => {
                                                const parsedValue = parseFloat(value);
                                                if (parsedValue < 0) {
                                                    return "Platinum Points must be greater than 0";
                                                }
                                                return true;
                                            }
                                        })}
                                        placeholder={"Points"}
                                        error={errors?.platinum}
                                        messages={{
                                            required: "Platinum Points is required",
                                            validate : "Platinum Points should be greater than Silver and Gold Points and greater than 0"
                                        }}
                                        isEdit={isEdit}
                                    />

                                </div>
                                <div className="flex justify-end">
                                    <Button text={"Submit"} className={`w-[100%] my-4`} smallBtn />
                                </div>
                            </form>
                        </FormProvider>
                    </div>
                </div>
            </ModalDropdown>
        </>
    );
};

export default AddTarget;
